import { FONT_CHAR_MAP } from 'signer-app/utils/font-char-map';

const fonts = Object.keys(FONT_CHAR_MAP);

export default fonts;
